"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationClaimAmount = exports.GeographicalArea = exports.FamilySituation = exports.TripDuration = exports.Variant = exports.TripType = exports.protobufPackage = void 0;
/* eslint-disable */
exports.protobufPackage = 'qover.dojo.travel.v1';
var TripType;
(function (TripType) {
    TripType["TRIP_TYPE_UNSPECIFIED"] = "TRIP_TYPE_UNSPECIFIED";
    TripType["TRIP_TYPE_SINGLE_TRIP"] = "TRIP_TYPE_SINGLE_TRIP";
    TripType["TRIP_TYPE_MULTI_TRIP"] = "TRIP_TYPE_MULTI_TRIP";
    TripType["TRIP_TYPE_YEAR_TRIP"] = "TRIP_TYPE_YEAR_TRIP";
})(TripType = exports.TripType || (exports.TripType = {}));
var Variant;
(function (Variant) {
    Variant["VARIANT_UNSPECIFIED"] = "VARIANT_UNSPECIFIED";
    Variant["VARIANT_STANDARD"] = "VARIANT_STANDARD";
    Variant["VARIANT_PREMIUM"] = "VARIANT_PREMIUM";
})(Variant = exports.Variant || (exports.Variant = {}));
var TripDuration;
(function (TripDuration) {
    TripDuration["TRIP_DURATION_UNSPECIFIED"] = "TRIP_DURATION_UNSPECIFIED";
    TripDuration["TRIP_DURATION_CITY_TRIP"] = "TRIP_DURATION_CITY_TRIP";
    TripDuration["TRIP_DURATION_SHORT_TRIP"] = "TRIP_DURATION_SHORT_TRIP";
    TripDuration["TRIP_DURATION_LONG_TRIP"] = "TRIP_DURATION_LONG_TRIP";
    TripDuration["TRIP_DURATION_40DAYS"] = "TRIP_DURATION_40DAYS";
    TripDuration["TRIP_DURATION_60DAYS"] = "TRIP_DURATION_60DAYS";
})(TripDuration = exports.TripDuration || (exports.TripDuration = {}));
var FamilySituation;
(function (FamilySituation) {
    FamilySituation["FAMILY_SITUATION_UNSPECIFIED"] = "FAMILY_SITUATION_UNSPECIFIED";
    FamilySituation["FAMILY_SITUATION_SINGLE"] = "FAMILY_SITUATION_SINGLE";
    FamilySituation["FAMILY_SITUATION_COUPLE"] = "FAMILY_SITUATION_COUPLE";
    FamilySituation["FAMILY_SITUATION_FAMILY"] = "FAMILY_SITUATION_FAMILY";
})(FamilySituation = exports.FamilySituation || (exports.FamilySituation = {}));
var GeographicalArea;
(function (GeographicalArea) {
    GeographicalArea["GEOGRAPHICAL_AREA_UNSPECIFIED"] = "GEOGRAPHICAL_AREA_UNSPECIFIED";
    GeographicalArea["GEOGRAPHICAL_AREA_EUROPE"] = "GEOGRAPHICAL_AREA_EUROPE";
    GeographicalArea["GEOGRAPHICAL_AREA_WORLD"] = "GEOGRAPHICAL_AREA_WORLD";
})(GeographicalArea = exports.GeographicalArea || (exports.GeographicalArea = {}));
var CancellationClaimAmount;
(function (CancellationClaimAmount) {
    CancellationClaimAmount["CANCELLATION_CLAIM_AMOUNT_UNSPECIFIED"] = "CANCELLATION_CLAIM_AMOUNT_UNSPECIFIED";
    CancellationClaimAmount["CANCELLATION_CLAIM_AMOUNT_1K"] = "CANCELLATION_CLAIM_AMOUNT_1K";
    CancellationClaimAmount["CANCELLATION_CLAIM_AMOUNT_2_5K"] = "CANCELLATION_CLAIM_AMOUNT_2_5K";
    CancellationClaimAmount["CANCELLATION_CLAIM_AMOUNT_5K"] = "CANCELLATION_CLAIM_AMOUNT_5K";
})(CancellationClaimAmount = exports.CancellationClaimAmount || (exports.CancellationClaimAmount = {}));
